import { useAuthStore } from '../../stores/auth.store';
import { Navigate } from 'react-router-dom';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isLoggedIn } = useAuthStore();

  if (!isLoggedIn) {
    // If user is not logged in, redirect to the landing page route
    return <Navigate to="/" replace />;
  }

  // If user is logged in, render the protected content
  return children as React.ReactElement;
}